import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

// Material
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, } from '@angular/material/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';



// RXJS
import { forkJoin, Observable, tap, of, throwError } from 'rxjs';
import { switchMap, map, catchError, filter  } from 'rxjs/operators';

// Moment
import moment from 'moment';

import { APIService } from 'src/services/api-services/api-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIRepresentativeService } from 'src/services/api-services/api-representative-service';
import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APIServiceDealer } from 'src/services/api-services/api-service-dealer';
import { APIChannelOriginService } from 'src/services/api-services/api-channel-origin.service';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';
import { APIDocumentTypeService } from '../../../../services/api-services/api-document-type.service';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { APITermsAndPolitics } from 'src/services/api-services/api-terms-and-politics.service';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-formats';
import { CreateSchedulerData } from 'src/services/api-services/api-interfaces/api-interface-create-scheduler';
import { SchedulingComponent } from '../../scheduling.component';
import { VehicleRelationship } from '../../../../services/api-services/api-interfaces/vehicleRelationship.interface';
import { HelperService } from 'src/services/helperService';
import { ScheduleStateService } from 'src/services/scheduleStateService.service';
import DocumentType from 'src/services/api-services/api-interfaces/documentType.interface';
import { TranslateService } from '@ngx-translate/core';
import { TermsAndPolitics } from 'src/services/api-services/api-interfaces/api-interface-terms-and-politics';
import { PersonType } from 'src/services/api-services/api-interfaces/customerBasicData.interface';



// TODO: Move this to a separate file
const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};

const numbersOnlyValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const invalid = /[^0-9]/.test(control.value);
  return invalid ? {'numbersOnly': {value: control.value}} : null;
};

const noNumbersValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const hasNumbers = /[0-9]/.test(control.value);
  return hasNumbers ? {'noNumbers': {value: control.value}} : null;
};

const dotComValidator = (control: AbstractControl): { [key: string]: any } | null => {
  const valid = /\.com$/.test(control.value)
  return valid ? null : { 'dotCom': { value: control.value } }
};


function yesSelectedValidator(control: AbstractControl) {
  const value = control.value;
  if (value === true) {
    return null; // The form is valid
  } else {
    return { 'yesSelected': true }; // The form is invalid
  }
}


@Component({
    selector: 'app-scheduling-plate-found-edit.dialog',
    templateUrl: './scheduling-plate-found-edit.dialog.html',
    styleUrls: ['./scheduling-plate-found-edit.dialog.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        TitleCasePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})

export class SchedulingPlateFoundEditDialog implements OnInit {

  data$?: Observable<any>;
  error?: string;
  mileages;
  isAdvisorSelected;
  savingSchedule = false
  scheduleData$ = new Observable<any>();
  currentUserRoleId = Number(this.helperService.user.role.roleId);
  allServices: any[] =[];
  appointmentSchedule;
  brandsAvailable: any[] = [];
  countryBrandRetaildIdSelected: any;
  isSaving = false;
  allWorkshopBlockedServices: any[] = [];
  allAdvisorBlockedServices: any[] = []
  allAvailableAdvisors: any[] = [];
  termsAndpoliticsLink: string = ""
  fecha1;
  hora1;
  advisorsAndSchedules: any[] = [];
  isNewUser = true;
  isThereABlockForRole = false;
  specificChannel;
  currentLanguage
  charCount: number = 0;
  showLastName = true;
  companyType: string = '';
  

  // Used when a customer is found, you get Ids not names These are filled in the "forkJoin" function
  customerPersonTypeName: string | "" | undefined;
  customerDocumentTypeName: string | "" | undefined;
  customerVehicleRelationShipName: string | "" | undefined;
  personTypes: PersonType[] = [];
  documentTypesByPersonType: any[] = [];
  representativeDocumentTypes: any[] = [];
  // Edit button on top of the html for owner
  isEditingOwner= true;
  countryId= Number(this.helperService.user.countryId)
  editButton= false;
  isEditable= false;
  //--
 YearsShow = Array.from(
  { length: new Date().getFullYear() + 2 - 2000 },
  (_, i) => (2000 + i).toString()
).reverse();
EnableVehicleandModel = false
  scheduleForm = this.fb.group({
    owner: this.fb.group({
      nombres: ["", [ Validators.required, noSpecialCharsValidator, noNumbersValidator ]],
      apellidos: ["", [ Validators.required, noSpecialCharsValidator, noNumbersValidator ]],
      tipoDePersona: [null as number | null, Validators.required],
      tipoDeDocumento: [null as number | null, Validators.required],
      numeroDeDocumento: [  '', [ Validators.required, noSpecialCharsValidator]],
      relacionClienteVehiculo: ["", Validators.required],
      celular: ["", [ Validators.required, numbersOnlyValidator ]],
      email: [ "", [ Validators.required, emailValidator,noSpecialCharsValidator ]],
      placa: ["", [ Validators.required, Validators.minLength(5)]],
      vin: ["",],
      año: [, Validators.required],
      model: [, Validators.required],
    }),
    schedule: this.fb.group({
      marca: ["", ],
      ciudad: ["", ],
      tipoDeServicio: ["", ],
      taller: ["", ],
      asesor: ["",],
      kilometraje: ["",[Validators.required] ],
      canal: ["",[Validators.required] ],
      fecha: ["", ],
      hora: ["", ],
      observacion: ["", ],
    }),
    representative: this.fb.group({
      duenoSePresentara: true,
      nombresRepresentante: ["", [Validators.required,noNumbersValidator]],
      apellidosRepresentante: ["", [Validators.required,noNumbersValidator]],
      tipoDeDocumentoRepresentante: ["", [Validators.required]],
      numeroDeDocumentoRepresentante: ["", [Validators.required]],
      // relacionClienteVehiculoRepresentante: ["",],
      celularRepresentante: ["", [Validators.required]],
      emailRepresentante: ["",[Validators.required, dotComValidator]],
    }),
    termsAndPolitics: this.fb.group({
      terminos: [false, [Validators.required, Validators.requiredTrue]],
      politicas: [false,],
      DataPeru:[false]
    })
  })

  constructor(
    public dialogRef: MatDialogRef<SchedulingComponent>,
    public customerbasicdataService: APICustomerBasicDataService,
    public schedulerService: APISchedulerService,
    public ServiceAdvisorApi: APIServiceAdvisorService,
    public WorkshopService : APIWorkshopService,
    public RepresentativeServiceApi: APIRepresentativeService,
    public Service: APIService,
    public ServiceSchedule: APIServiceSchedule,
    public customScheduleService: APICustomScheduleService,
    public ServiceDealer: APIServiceDealer,
    public serviceAdvisorBlockedSchedule:  APIServiceAdvisorBlockedSchedule,
    @Inject(MAT_DIALOG_DATA) public appointment: any,

    public titleCasePipe: TitleCasePipe,
    private fb: FormBuilder,
    public channelOriginService: APIChannelOriginService,
    public typeOfDocumentService: APIDocumentTypeService,
    public VehicleRelationshipService: APIVehicleRelationship,
    public helperService: HelperService,
    public brandService: APIBrandsService,
    public termAndPoliticsService: APITermsAndPolitics,
    public scheduleStateService: ScheduleStateService,
    private translate: TranslateService,

  ) {
    // console.log(this.appointment)
    if (this.helperService.user.role.roleId===1) {
      this.appointmentSchedule = this.titleCasePipe.transform(`${new Date(this.appointment.start).toLocaleDateString(this.helperService.user.language, { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true })}`);
    } else {
      this.appointmentSchedule = this.titleCasePipe.transform(`${new Date(this.appointment.start).toLocaleDateString(this.helperService.user.language, { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true })} - ${new Date(this.appointment.end).toLocaleTimeString(this.helperService.user.language, { hour: 'numeric', minute: 'numeric', hour12: true })}`);
    }
    }




    
    ngOnInit(): void {
     
    // this.helperService.user.language = 'fr-BE'
    this.currentLanguage = this.helperService.user.language;
     
    
      const model = this.appointment.modelDescription;

    this.EnableVehicleandModel = !!model && model.trim() !== "";

    this.fecha1 = moment(this.appointment.start).format('YYYY-MM-DD HH:mm').split(" ")[0];
    this.hora1 =moment(this.appointment.start).format('YYYY-MM-DD HH:mm').split(" ")[1]

    // checking if its a new user/the plate was found or not
    // this.isEditingOwner = this.appointment?.customerId ? false: true;
    // this.isEditable = this.appointment?.customerId ? true: false;
    this.isNewUser = this.appointment?.customerId ? false: true;

    if(this.appointment?.customerId){
      this.isEditingOwner = false;
      this.isEditable = true;
    }
    //--

    this.isAdvisorSelected = this.appointment.advisor && this.appointment.advisor.advisorId ? true : false;


    this.scheduleForm.reset({
      owner: {
        nombres: this.appointment && this.appointment.customerId ? this.appointment.firstName : "",
        apellidos: this.appointment && this.appointment.customerId ? this.appointment.lastName : "",
        tipoDePersona: this.appointment?.customerId ? Number(this.appointment.customerPersonTypeId) : null,
        tipoDeDocumento:  this.appointment && this.appointment.customerId ? this.appointment.documentTypeId : null,
        numeroDeDocumento: this.appointment && this.appointment.customerId ? this.appointment.identification : "",
        relacionClienteVehiculo: this.appointment && this.appointment.customerId ? this.appointment.relationshipVehicleId : "",
        celular: this.appointment && this.appointment.customerId ? this.appointment.phone : "",
        email: this.appointment && this.appointment.customerId ? this.appointment.email : "",
        placa: this.appointment && this.appointment.vehicleId ? this.appointment.plate : "",
        vin: this.appointment && this.appointment.vehicleId ? this.appointment.vin : "",
        año:this.appointment && this.appointment.modelYear ? this.appointment.modelYear : "",
        model:this.appointment && this.appointment.modelDescription ? this.appointment.modelDescription : "",
      },
      schedule: {
        marca: this.appointment.brand && this.appointment.brand.brandId ? this.appointment.brand.brandId : "",
        ciudad: this.appointment.city && this.appointment.city.cityId ? this.appointment.city.cityId : "",
        tipoDeServicio: this.appointment.typeOfService && this.appointment.typeOfService.serviceId ? this.appointment.typeOfService.serviceId: "",
        taller: this.appointment.workshop && this.appointment.workshop.workshopId ? this.appointment.workshop.workshopId : "",
        asesor: this.appointment && this.appointment.advisor ? this.appointment.advisor.advisorId : "",
        fecha: this.appointment.start,
        hora: "",
        observacion: "",
        canal: ""
      },
      representative: {
        duenoSePresentara: true,
        nombresRepresentante: "",
        apellidosRepresentante: "",
        tipoDeDocumentoRepresentante: "",
        numeroDeDocumentoRepresentante: "",
        // relacionClienteVehiculoRepresentante: "",
        celularRepresentante: "",
        emailRepresentante: "",
      },
      termsAndPolitics: {
        terminos: false,
        politicas: false,DataPeru: false
      }
    })

    /*
      * Wait for all the calls to the backend to be completed
      * with "tap" get the name of the resource, its needed for "document type name" and "vehicle relationship name"
      * because you need a string not an id if the user is found
    */

    let observables: any = {
      channels: this.channelOriginService.getAllChannels().pipe(),
       personTypes: this.typeOfDocumentService
              .GetPersonTypeByCountryId(this.helperService.user.countryId)
              .pipe(
                catchError((error: any) => {
                  if (error.status === 401) this.helperService.logoutToken();
                  return throwError(() => error);
                })
              ),
      vehicleRelationships: this.VehicleRelationshipService.getAllVehicleRelationships().pipe(/*...*/),
    };
    if (this.currentUserRoleId === 1) {
      // id of the current user not the advisor selected for the appointment
      observables.appointments = this.customScheduleService.getSchedulerByAdvisor(this.helperService.user.advisorId).pipe( catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
          this.helperService.logoutToken()
        }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
      }))
      observables.advisorServices = this.Service.getAdvisorServicesForServiceAdvisorRol(this.helperService.user.advisorId);
      observables.advisorBrands = this.brandService.getBrandAdvisor(this.helperService.user.advisorId);
    }
    if(this.currentUserRoleId == 2 || this.currentUserRoleId == 6){
      observables.termsAndPolitics = this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.appointment.brand.brandId),this.helperService.user.countryId)
      // I want a list of all the blocked schedules - workshop and advisor
      observables.isThereABlock = this.getBlockedSchedulesToSchedule();
    }
    if (this.currentUserRoleId === 3 || this.currentUserRoleId === 4) {
      if(this.appointment.advisor?.advisorId){
        observables.isThereABlock = this.getBlockedSchedulesToSchedule();
      }
      const date= this.appointment.start.toISOString().split('T')[0]
      const time= moment(new Date(this.appointment.start)).format('h:mm A')
      const workshopId= this.appointment.workshop.workshopId
      if(this.appointment.advisor == undefined){
        observables.AvailableAdvisors = this.ServiceAdvisorApi.getAvailableAdvisors(date.trim(), time.trim(), workshopId, this.appointment.typeOfService.serviceId)
      }
      observables.termsAndPolitics = this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.appointment.brand.brandId),this.helperService.user.countryId)
    }


    this.data$ = forkJoin(observables).pipe(
      tap((results: any) => {        
        this.personTypes = results.personTypes ?? [];
        const personTypeId = this.scheduleForm.get('owner.tipoDePersona')?.value;
        this.updateLastNameVisibility(Number(personTypeId));
        this.loadDocumentTypesByPersonType(Number(personTypeId));
        this.loadRepresentativeDocumentTypes();
        const vehicleRelationShip: VehicleRelationship | undefined = results.vehicleRelationships.find((document) => document.relationshipVehicleId === this.appointment.relationshipVehicleId)
        this.customerVehicleRelationShipName = vehicleRelationShip?.relationshipName

        if(this.currentUserRoleId === 1){
          this.specificChannel = results.channels.find((channel) => channel.originId === 6)
          // this value is used only to show the name of the channel, the real value is sent on the save method
          this.scheduleForm.get("schedule.canal")?.setValue(this.specificChannel.originName)

          this.allServices = results.advisorServices;
          this.allWorkshopBlockedServices = results.appointments.blockedservicesByServiceAdvisor;
          this.allAdvisorBlockedServices = results.appointments.serviceAdvisorBlockedServices;
          this.brandsAvailable = results.advisorBrands;


          // * PASO 1: SE REVISAN BLOQUEOS POR TALLER

          // encontrar todos los bloqueos de todos los servicios que hagan match con el dia.
          this.allWorkshopBlockedServices.forEach( block =>{
            let days: any[] = [];

            // si el bloqueo es un rango de dias, obtener los dias intermedios entre la fecha inicial y final
            days = [...this.getMissingDays(block.initialDate, block.finalDate)]

            let formatedDate = this.formatDate(this.appointment.start)
            // dentro de esos dias hay alguno que coincida con la fecha de la cita?
            let blockFound = days.find(d => d === formatedDate)

            if(blockFound) {

              // sacar los horarios con horas si es un rango de horas
              let rangeHours = this.getMissingHours(block.hourInitial, block.hourFinal)

              // El bloqueo es de todo el dia ??
              if(block.hourInitial == '01:00:00' && block.hourFinal == '23:30:00'){
                // Lo quito de la lista de servicios disponibles
                this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
              }
              // si no es todo el dia es por horas
              // la hora en la que esta bloqueado el servicio interfiere con la hora en la que se quiere agendar la cita??
              else{

                // si coincide con la hora incial
                if(this.hora1 + ":00" === block.hourInitial){
                  this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
                }

                // esta dentro de el rango de horas
                if(rangeHours.find(h => h === (this.hora1 + ":00") )){
                  this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
                }
              }

            }

          })

          // * PASO 2: SE REVISAN BLOQUEOS POR ASESOR
          this.allAdvisorBlockedServices.forEach( block =>{
            let days: any[] = [];

            // si el bloqueo es un rango de dias, obtener los dias intermedios entre la fecha inicial y final
            days = [...this.getMissingDays(block.initialDateBlockedServices, block.finalDateBlockedServices)]

            let formatedDate = this.formatDate(this.appointment.start)
            // dentro de esos dias hay alguno que coincida con la fecha de la cita?
            let blockFound = days.find(d => d === formatedDate)

            if(blockFound) {

              // sacar los horarios con horas si es un rango de horas
              let rangeHours = this.getMissingHours(block.hourInitialBlockedServices, block.hourFinaBlockedServices)

              // El bloqueo es de todo el dia ??
              if(block.hourInitialBlockedServices == '01:00:00' && block.hourFinaBlockedServices == '23:30:00'){
                // Lo quito de la lista de servicios disponibles
                this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
              }
              // si no es todo el dia es por horas
              // la hora en la que esta bloqueado el servicio interfiere con la hora en la que se quiere agendar la cita??
              else{
                // si coincide con la hora incial
                if(this.hora1 + ":00" === block.hourInitialBlockedServices){
                  this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
                }

                // esta dentro de el rango de horas
                if(rangeHours.find(h => h === (this.hora1 + ":00") )){
                  this.allServices = this.allServices.filter(service => service.serviceName !== block.serviceName);
                }
              }

            }

          })


        }
        // fin rol 1


        if(this.currentUserRoleId === 2 || this.currentUserRoleId === 6){
          this.specificChannel = results.channels.find((channel) => channel.originId === 6)
          // this value is used only to show the name of the channel, the real value is sent on the save method
          this.scheduleForm.get("schedule.canal")?.setValue(this.specificChannel.originName)

          if(results.TermsAndPolitics){
          if(results.termsAndPolitics[0]?.UrlAddress){
            this.termsAndpoliticsLink = results.termsAndPolitics[0].UrlAddress;
          }
          else{
            this.termsAndpoliticsLink = ""
          }}
          this.isThereABlockForRole = results.isThereABlock;
        }

        if(this.currentUserRoleId === 3 || this.currentUserRoleId === 4){
          this.isThereABlockForRole = results.isThereABlock;
          this.allAvailableAdvisors=results.AvailableAdvisors

          if(results.termsAndPolitics){
          if(results.termsAndPolitics[0]?.UrlAddress){
            this.termsAndpoliticsLink = results.termsAndPolitics[0].UrlAddress;
          }
          else{
            this.termsAndpoliticsLink = ""
          }}
        }

      })
    );


     // SERVICE ADVISOR
    if(this.currentUserRoleId === 1){

      // add Validators
      this.scheduleForm.get("schedule.marca")?.setValidators(Validators.required)
      this.scheduleForm.get("schedule.tipoDeServicio")?.setValidators(Validators.required)
      this.scheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])
      this.scheduleForm.get("schedule.canal")?.setValidators(Validators.required)
      this.scheduleForm.get("schedule.asesor")?.setValue(String(this.helperService.user.advisorId))


      this.scheduleForm.get("schedule")?.get("kilometraje")?.disable()

      this.scheduleForm.get("schedule")?.get("marca")?.valueChanges.subscribe( brand => {

        this.termAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(brand),this.helperService.user.countryId).subscribe(
          data => {
            if(data[0]?.UrlAddress){
              this.termsAndpoliticsLink = data[0].UrlAddress;
            }
            else{
              this.termsAndpoliticsLink = ""
            }
          }
        )

        if(this.scheduleForm.get("schedule")?.get("marca")?.value){
          this.scheduleForm.get("schedule")?.get("kilometraje")?.enable()
        }

        // TODO: add loading to this ...thing
        this.WorkshopService.getCountryBrandRetailIdByBrandAndWorkshopId(Number(brand),this.helperService.user.workshopId)
        .subscribe(data => {
          this.countryBrandRetaildIdSelected = data[0].countryBrandRetailId;
        })

      })

    }
    // END SERVICE ADVISOR
      this.scheduleForm.get('owner.tipoDePersona')?.valueChanges
        .pipe(
          filter(() => this.isEditingOwner === true),
          tap((id) => {
            this.updateLastNameVisibility(Number(id));
            this.scheduleForm.get('owner.tipoDeDocumento')?.reset(null);
            this.documentTypesByPersonType = [];
          }),
          switchMap((personTypeId: any) => {
            if (!personTypeId) return of([]);
            return this.typeOfDocumentService.GetDocumentTypeByCountryIdByPersonId(
              this.helperService.user.countryId,
              Number(personTypeId)
            ).pipe(
              catchError((error: any) => {
                if (error.status === 401) this.helperService.logoutToken();
                console.error('Validation Error:', error);
                return of([]);
              })
            );
          })
        )
        .subscribe((docs: any[]) => {
          this.documentTypesByPersonType = docs ?? [];
        });
    // WORKSHOP
    if(this.currentUserRoleId === 2 || this.currentUserRoleId === 6){

      // add validators
      this.scheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])
      this.scheduleForm.get("schedule.canal")?.setValidators(Validators.required)

      this.WorkshopService.getCountryBrandRetailIdByBrandAndWorkshopId(this.appointment.brand.brandId, this.helperService.user.workshopId)
      .subscribe(data => {
        this.countryBrandRetaildIdSelected = data[0].countryBrandRetailId;
      })

    }
    //-- END WORKSHOP


    // CONTACT CENTER
    if(this.currentUserRoleId === 3 || this.currentUserRoleId === 4){

      // add validators
      this.scheduleForm.get("schedule.asesor")?.setValidators(Validators.required)
      this.scheduleForm.get("schedule.kilometraje")?.setValidators([Validators.required, numbersOnlyValidator, noSpecialCharsValidator])
      this.scheduleForm.get("schedule.canal")?.setValidators(Validators.required)
    }
    // END CONTACT CENTER

    // is owner present?
    this.scheduleForm.get("representative")?.get("duenoSePresentara")?.valueChanges.subscribe( isOwnerPresent => {
      if(isOwnerPresent == false){

        this.scheduleForm.get("representative.nombresRepresentante")?.setValidators([Validators.required, noSpecialCharsValidator,noNumbersValidator])
        this.scheduleForm.get("representative.apellidosRepresentante")?.setValidators([Validators.required, noSpecialCharsValidator,noNumbersValidator])
        this.scheduleForm.get("representative.tipoDeDocumentoRepresentante")?.setValidators([Validators.required])
        this.scheduleForm.get("representative.numeroDeDocumentoRepresentante")?.setValidators([Validators.required])
        // this.scheduleForm.get("representative.relacionClienteVehiculoRepresentante")?.setValidators([Validators.required])
        this.scheduleForm.get("representative.celularRepresentante")?.setValidators([Validators.required, numbersOnlyValidator])
        this.scheduleForm.get("representative.emailRepresentante")?.setValidators([Validators.required, Validators.email])
      }
      else{
        // Its necessary to repeat the code like this
        // clearing validators do not propagate to child elements of the form.
        this.scheduleForm.get("representative")?.clearValidators();
        this.scheduleForm.get("representative.nombresRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.nombresRepresentante")?.updateValueAndValidity();
        this.scheduleForm.get("representative.apellidosRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.apellidosRepresentante")?.updateValueAndValidity()
        this.scheduleForm.get("representative.tipoDeDocumentoRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.tipoDeDocumentoRepresentante")?.updateValueAndValidity()
        this.scheduleForm.get("representative.numeroDeDocumentoRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.numeroDeDocumentoRepresentante")?.updateValueAndValidity()
        // this.scheduleForm.get("representative.relacionClienteVehiculoRepresentante")?.clearValidators()
        // this.scheduleForm.get("representative.relacionClienteVehiculoRepresentante")?.updateValueAndValidity()
        this.scheduleForm.get("representative.celularRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.celularRepresentante")?.updateValueAndValidity()
        this.scheduleForm.get("representative.emailRepresentante")?.clearValidators()
        this.scheduleForm.get("representative.emailRepresentante")?.updateValueAndValidity()

      }
      this.scheduleForm.get("representative")?.updateValueAndValidity();
    })


  }
  // END ON INIT

  private loadDocumentTypesByPersonType(personTypeId: number | null | undefined): void {
    if (!personTypeId) {
      this.documentTypesByPersonType = [];
      this.scheduleForm.get('owner.tipoDeDocumento')?.reset(null);
      return;
    }

    this.typeOfDocumentService
      .GetDocumentTypeByCountryIdByPersonId(this.helperService.user.countryId, Number(personTypeId))
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) this.helperService.logoutToken();
          console.error('Error loading document types:', error);
          this.documentTypesByPersonType = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.documentTypesByPersonType = docs ?? [];
        const currentDoc = this.scheduleForm.get('owner.tipoDeDocumento')?.value;
        const stillValid = this.documentTypesByPersonType.some(d => Number(d.typeId) === Number(currentDoc));

        if (!stillValid) {
          this.scheduleForm.get('owner.tipoDeDocumento')?.reset(null);
        }
      });
  }

  private loadRepresentativeDocumentTypes(): void {
    const individualPersonType = this.personTypes.find(
      (p) => (p.typeLabel ?? '').trim().toLowerCase() === 'individual'
    );

    if (!individualPersonType?.typeId) {
      this.representativeDocumentTypes = [];
      return;
    }

    this.typeOfDocumentService
      .GetDocumentTypeByCountryIdByPersonId(
        this.helperService.user.countryId,
        Number(individualPersonType.typeId)
      )
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) this.helperService.logoutToken();
          console.error('Error loading representative document types:', error);
          this.representativeDocumentTypes = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.representativeDocumentTypes = docs ?? [];
      });
  }  

  editOwnerAndChangeOwner(status:number){

    switch(status){
      case 1:
        // Edit Data owner

        this.editButton = false;
        this.isEditingOwner = true;
        this.scheduleForm.get("owner")?.get('numeroDeDocumento')!.disable();
        this.scheduleForm.get("owner")?.get('tipoDeDocumento')!.disable();
        this.scheduleForm.get("owner")?.get('tipoDePersona')!.disable();
       
        this.loadDocumentTypesByPersonType(Number(this.tipoDePersona?.value));
      break;
      case 2 :
        // Update Data owner
        this.scheduleForm.get("owner")?.get('numeroDeDocumento')!.enable();
        this.scheduleForm.get("owner")?.get('tipoDeDocumento')!.enable();
        this.scheduleForm.get("owner")?.get('tipoDePersona')?.enable();
        this.scheduleForm.get("owner")?.reset();
        this.scheduleForm.get("owner")?.get("placa")?.setValue(this.appointment.plate)
        this.isEditingOwner = true;
        this.editButton = false;
        this.appointment.customerId = 0;
        this.documentTypesByPersonType=[];

      break;
      case 3:
        // show tooltip
        this.editButton = !this.editButton;
      break;
    }
  }

  private updateLastNameVisibility(personTypeId: number | null | undefined): void {
    const lastNameCtrl = this.scheduleForm.get('owner.apellidos');
    const selected = this.personTypes.find(
      p => Number(p.typeId) === Number(personTypeId)
    );

    const isCompany = (selected?.typeLabel ?? '').toLowerCase() === 'company';
    this.companyType = isCompany ? 'Company' : 'Individual';
    this.showLastName = !isCompany;

    if (isCompany) {
      lastNameCtrl?.clearValidators();
      lastNameCtrl?.setValue('NaN');
      lastNameCtrl?.updateValueAndValidity({ emitEvent: false });
    } else {
      lastNameCtrl?.setValidators([Validators.required, noSpecialCharsValidator, noNumbersValidator]);
      if (lastNameCtrl?.value === 'NaN') lastNameCtrl?.setValue('');
      lastNameCtrl?.updateValueAndValidity({ emitEvent: false });
    }
  }

  onSave() {

    this.isSaving = true;
    const ownerRaw = this.scheduleForm.get('owner')?.getRawValue();
    let newSchedule : CreateSchedulerData | any;
    let dateSelected = this.formatoFecha(moment(this.scheduleForm.get("schedule")?.get("fecha")?.value).format('YYYY-MM-DD HH:mm').split(" ")[0],this.helperService.user.language)

    if(this.currentUserRoleId === 1){
      let selectedBrandName = this.brandsAvailable.find(brand => brand.brandId === this.scheduleForm.get("schedule")?.get("marca")?.value).brandName;
      newSchedule = {
        createSchedulerDTO: {
          scheduleId: 0,
          customerId: Number(this.appointment.customerId ? this.appointment.customerId : 0),
          advisorId: Number(this.helperService.user.advisorId),
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          date: this.fecha1,
          time: this.hora1 + ":00",
          observations: String(this.scheduleForm.get("schedule")?.get("observacion")?.value),
          ownerOnSite: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value),
          termsAndConditions: this.scheduleForm.get("termsAndPolitics")?.get("terminos")?.value , // has to be true to submit the form anyway
          dataProtectionPolitics: this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value, // has to be true to submit the form anyway
          representativeId: Number(this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value == true ? null : 0), // ?? null?? si el dueño va es null si no es 0
          decisionMaking: true, // true siempre
          countryBrandRetailId: this.countryBrandRetaildIdSelected,
          schedulerStatusId: 1,
          serviceId: Number(this.scheduleForm.get("schedule")?.get("tipoDeServicio")?.value),
          originId: Number(this.specificChannel.originId),
          DataProcessing: false
        },
        vehicleDataDTO: {
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          plate:String( this.scheduleForm.get("owner")?.get("placa")?.value).toUpperCase(),
          vin: String(this.scheduleForm.get("owner")?.get("vin")?.value),
        
          brand: selectedBrandName,
          mileage: String(this.scheduleForm.get("schedule")?.get("kilometraje")?.value),
          customerId: this.appointment.customerId ? this.appointment.customerId : 0,
          ModelDescription: String(this.scheduleForm.get("owner")?.get("model")?.value),
          ModelYear: String(this.scheduleForm.get("owner")?.get("año")?.value)
        },
        customerBasicDataDTO: {
          customerId: this.appointment.customerId ? this.appointment.customerId : 0,
          sapCustomerId: "", // string vacia o null?
          identification: String(ownerRaw?.numeroDeDocumento), 
          personTypeId: Number(ownerRaw?.tipoDePersona),
          documentType: Number(ownerRaw?.tipoDeDocumento),
          firstName: String(this.scheduleForm.get("owner")?.get("nombres")?.value),
          lastName: this.showLastName ? String(this.scheduleForm.get("owner")?.get("apellidos")?.value):'NaN',
          email: String(this.scheduleForm.get("owner")?.get("email")?.value),
          phone: String(this.scheduleForm.get("owner")?.get("celular")?.value),
          address: "", // nunca se pide
          relationshipVehicleId: Number(this.scheduleForm.get("owner")?.get("relacionClienteVehiculo")?.value),
          dataPrivacy: this.countryId === 2 ? this.scheduleForm.get("termsAndPolitics")?.get("DataPeru")?.value : this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value

        },
        representativeDTO: {
          representativeId: 0, // 0 siempre al agendar ??
          customerId: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value) == true ? 0 : (this.appointment.customerId || 0),
          identification: String(this.scheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")?.value),
          documentType: Number(this.scheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")?.value),
          firstName: String(this.scheduleForm.get("representative")?.get("nombresRepresentante")?.value),
          lastName: String( this.scheduleForm.get("representative")?.get("apellidosRepresentante")?.value),
          email: String( this.scheduleForm.get("representative")?.get("emailRepresentante")?.value),
          phone: String(this.scheduleForm.get("representative")?.get("celularRepresentante")?.value),
          address: "" // nunca se pide...
        },
        utmDTO: {
          UtmSource:"" ,
          UtmCampaign:"" ,
          UtmMedium:"" ,
          UtmContent:"" ,
          UtmTerm: ""
        },
         RecaptchaToken:"OK"
      }
    }

    if(this.currentUserRoleId === 2 || this.currentUserRoleId === 6){
      newSchedule = {
        createSchedulerDTO: {
          scheduleId: 0,
          customerId: Number(this.appointment.customerId ? this.appointment.customerId : 0),
          advisorId: Number(this.appointment.advisor.advisorId),
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          date: this.fecha1,
          time: this.hora1 + ":00",
          observations: String(this.scheduleForm.get("schedule")?.get("observacion")?.value),
          ownerOnSite: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value),
          termsAndConditions: this.scheduleForm.get("termsAndPolitics")?.get("terminos")?.value, // has to be true to submit the form anyway
          dataProtectionPolitics: this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value, // has to be true to submit the form anyway
          representativeId: Number(this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value == true ? null : 0), // ?? null?? si el dueño va es null si no es 0
          decisionMaking: true, // true siempre
          countryBrandRetailId: this.countryBrandRetaildIdSelected,
          schedulerStatusId: 1,
          serviceId: Number(this.scheduleForm.get("schedule")?.get("tipoDeServicio")?.value),
          originId: Number(this.specificChannel.originId),
          DataProcessing: false
        },
        vehicleDataDTO: {
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          plate:String( this.scheduleForm.get("owner")?.get("placa")?.value).toUpperCase(),
          vin: String(this.scheduleForm.get("owner")?.get("vin")?.value),
    
          brand: this.appointment.brand.brandName,
          mileage: String(this.scheduleForm.get("schedule")?.get("kilometraje")?.value),
          customerId: this.appointment.customerId ? this.appointment.customerId : 0,
          ModelDescription: String(this.scheduleForm.get("owner")?.get("model")?.value),
          ModelYear: String(this.scheduleForm.get("owner")?.get("año")?.value)
        },
        customerBasicDataDTO: {
          customerId: Number(this.appointment.customerId ? this.appointment.customerId : 0),
          sapCustomerId: "", // string vacia o null?
          identification: String(ownerRaw?.numeroDeDocumento), 
          personTypeId: Number(ownerRaw?.tipoDePersona),
          documentType: Number(ownerRaw?.tipoDeDocumento),
          firstName: String(this.scheduleForm.get("owner")?.get("nombres")?.value),
          lastName: this.showLastName ? String(this.scheduleForm.get("owner")?.get("apellidos")?.value):'NaN',
          email: String(this.scheduleForm.get("owner")?.get("email")?.value),
          phone: String(this.scheduleForm.get("owner")?.get("celular")?.value),
          address: "", // nunca se pide
          relationshipVehicleId: Number(this.scheduleForm.get("owner")?.get("relacionClienteVehiculo")?.value),
          dataPrivacy:  this.countryId === 2 ? this.scheduleForm.get("termsAndPolitics")?.get("DataPeru")?.value : this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value
        },
        representativeDTO: {
          representativeId: 0, // 0 siempre al agendar ??
          // here the "else" its because it may be a new user goes into the else can't find customer id so it has to be 0
          customerId: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value) == true ? 0 : (this.appointment.customerId || 0),
          identification: String(this.scheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")?.value),
          documentType: Number(this.scheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")?.value),
          firstName: String(this.scheduleForm.get("representative")?.get("nombresRepresentante")?.value),
          lastName: String( this.scheduleForm.get("representative")?.get("apellidosRepresentante")?.value),
          email: String( this.scheduleForm.get("representative")?.get("emailRepresentante")?.value),
          phone: String(this.scheduleForm.get("representative")?.get("celularRepresentante")?.value),
          address: "" // nunca se pide...
        },
        utmDTO: {
          UtmSource:"" ,
          UtmCampaign:"" ,
          UtmMedium:"" ,
          UtmContent:"" ,
          UtmTerm: ""
        },
         RecaptchaToken:"OK"
      }
    }

    if( this.currentUserRoleId === 3 || this.currentUserRoleId === 4){
      newSchedule = {
        createSchedulerDTO: {
          scheduleId: 0,
          customerId: Number(this.appointment.customerId ? this.appointment.customerId : 0),
          advisorId: Number(this.scheduleForm.get("schedule")?.get("asesor")?.value),
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          date: this.fecha1,
          time: this.hora1 + ":00",
          observations: String(this.scheduleForm.get("schedule")?.get("observacion")?.value),
          ownerOnSite: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value),
          termsAndConditions: this.scheduleForm.get("termsAndPolitics")?.get("terminos")?.value , // has to be true to submit the form anyway
          dataProtectionPolitics: this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value, // has to be true to submit the form anyway
          representativeId: Number(this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value == true ? null : 0), // ?? null?? si el dueño va es null si no es 0
          decisionMaking: true, // true siempre
          countryBrandRetailId: this.appointment.workshop.workshopId,
          schedulerStatusId: 1,
          serviceId: Number(this.scheduleForm.get("schedule")?.get("tipoDeServicio")?.value),
          originId: Number(this.scheduleForm.get("schedule")?.get("canal")?.value),
          DataProcessing: false

        },
        vehicleDataDTO: {
          vehicleId: Number(this.appointment.vehicleId ? this.appointment.vehicleId : 0),
          plate:String( this.scheduleForm.get("owner")?.get("placa")?.value).toUpperCase(),
          vin: String(this.scheduleForm.get("owner")?.get("vin")?.value),
          brand: this.appointment.brand.brandName,
          mileage: String(this.scheduleForm.get("schedule")?.get("kilometraje")?.value),
          customerId: this.appointment.customerId ? this.appointment.customerId : 0,
          ModelDescription: String(this.scheduleForm.get("owner")?.get("model")?.value),
          ModelYear: String(this.scheduleForm.get("owner")?.get("año")?.value)
        },
        customerBasicDataDTO: {
          customerId: Number(this.appointment.customerId ? this.appointment.customerId : 0),
          sapCustomerId: "", // string vacia o null?
          identification: String(ownerRaw?.numeroDeDocumento), 
          personTypeId: Number(ownerRaw?.tipoDePersona),
          documentType: Number(ownerRaw?.tipoDeDocumento),
          firstName: String(this.scheduleForm.get("owner")?.get("nombres")?.value),
          lastName: this.showLastName ? String(this.scheduleForm.get("owner")?.get("apellidos")?.value):'NaN',
          email: String(this.scheduleForm.get("owner")?.get("email")?.value),
          phone: String(this.scheduleForm.get("owner")?.get("celular")?.value),
          address: "", // nunca se pide
          relationshipVehicleId: Number(this.scheduleForm.get("owner")?.get("relacionClienteVehiculo")?.value),
          dataPrivacy:  this.countryId === 2 ? this.scheduleForm.get("termsAndPolitics")?.get("DataPeru")?.value : this.scheduleForm.get("termsAndPolitics")?.get("politicas")?.value

        },
        representativeDTO: {
          representativeId: 0, // 0 siempre al agendar ??
          customerId: Boolean( this.scheduleForm.get("representative")?.get("duenoSePresentara")?.value) == true ? 0 : (this.appointment.customerId || 0),
          identification: String(this.scheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")?.value),
          documentType: Number(this.scheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")?.value),
          firstName: String(this.scheduleForm.get("representative")?.get("nombresRepresentante")?.value),
          lastName: String( this.scheduleForm.get("representative")?.get("apellidosRepresentante")?.value),
          email: String( this.scheduleForm.get("representative")?.get("emailRepresentante")?.value),
          phone: String(this.scheduleForm.get("representative")?.get("celularRepresentante")?.value),
          address: "" // nunca se pide...
        },
        utmDTO: {
          UtmSource:"" ,
          UtmCampaign:"" ,
          UtmMedium:"" ,
          UtmContent:"" ,
          UtmTerm: ""
        },
         RecaptchaToken:"OK"
      }
    }

    newSchedule.createSchedulerDTO.UserId =  Number(this.helperService.user.userid);

    let serviceNameSelected: string ="";

    if(this.currentUserRoleId === 1){
       serviceNameSelected = this.allServices.find(service => service.serviceId === this.scheduleForm.get("schedule")?.get("tipoDeServicio")?.value).serviceName
    }
    else{
      serviceNameSelected = this.appointment.typeOfService.serviceName
    }


    this.schedulerService.postDataScheduler(newSchedule)
    .subscribe({
      next:  (res) => {

        if (res.scheduleResult.scheduleId) {
          this.isSaving = false
          const translateText= this.translate.instant('ScheduleSavedSuccess', {
            serviceNameSelected: this.translate.instant(serviceNameSelected),
            dateSelected: dateSelected,
            time: moment(new Date( this.appointment.start)).format('h:mm A')
          });
          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateText

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
          this.scheduleStateService.changeScheduleState(true)
        } else {
          const trasnlateTextFail = this.translate.instant("ScheduleSavedFailure",{Date:this.appointmentSchedule})
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =trasnlateTextFail

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
          this.dialogRef.close(this.appointment);
        }

      },
      error: (err) => {

        if(err.status === 401){
          this.helperService.logoutToken()
        }
        else{
        console.error("Error agendando cita", err);
        const trasnlateTextFail = this.translate.instant("ScheduleSavedFailure",{Date:this.appointmentSchedule})
        this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =trasnlateTextFail

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
        this.dialogRef.close(this.appointment);}
      },
      complete: () => {
           this.dialogRef.close(this.appointment);
      }
    });


  }



  getMissingDays(initialDate, finalDate) {
    // Convert input strings into Date objects
    const startDate = new Date(initialDate);
    const endDate = new Date(finalDate);

    // Calculate the number of days between the two dates
    const numDays = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    // Create an array to store the missing days
    const missingDays: any[] = [];

    // Add the initial date to the array
    missingDays.push(startDate.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).replace(/\//g, '-'));

    // Loop through each day between the two dates and add it to the array
    for (let i = 1; i < numDays - 1; i++) {
      const currentDate = new Date(startDate.getTime() + (i * 24 * 60 * 60 * 1000));
      missingDays.push(currentDate.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).replace(/\//g, '-'));
    }

    // Add the final date to the array
    missingDays.push(endDate.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).replace(/\//g, '-'));

    return missingDays;
  }

  formatDate(inputDate) {
    const date = new Date(inputDate);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  getMissingHours(initialHour, finalHour) {
    // Parse input times as UTC times
    const startDate = new Date('1970-01-01T' + initialHour + 'Z');
    const endDate = new Date('1970-01-01T' + finalHour + 'Z');

    // Calculate the number of FIFTEEN (15) between the two times
    const numHalfHours = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 15)) + 1;

    // Create an array to store the missing hours
    const missingHours: any[] = [];

    // Add the initial hour to the array
    missingHours.push(startDate.getUTCHours().toString().padStart(2, '0') + ':' + startDate.getUTCMinutes().toString().padStart(2, '0') + ':' + startDate.getUTCSeconds().toString().padStart(2, '0'));

    // Loop through each FIFTEEN (15) between the two times and add it to the array
    for (let i = 1; i < numHalfHours - 1; i++) {
      const currentHour = new Date(startDate.getTime() + (i * 15 * 60 * 1000));
      missingHours.push(currentHour.getUTCHours().toString().padStart(2, '0') + ':' + currentHour.getUTCMinutes().toString().padStart(2, '0') + ':' + currentHour.getUTCSeconds().toString().padStart(2, '0'));
    }

    // Add the last missing hour, which is 15 minutes before the final hour
    const lastMissingHour = new Date(endDate.getTime() - (15 * 60 * 1000));
    missingHours.push(lastMissingHour.getUTCHours().toString().padStart(2, '0') + ':' + lastMissingHour.getUTCMinutes().toString().padStart(2, '0') + ':' + lastMissingHour.getUTCSeconds().toString().padStart(2, '0'));

    return missingHours;
  }

  formatoFecha(fecha: string, region:string): string {

    let fechaObj = new Date(fecha + 'T00:00:00');
    fechaObj.setMinutes(fechaObj.getTimezoneOffset());

    // Define days and months names for Spanish and English
    const diasSemana = {
      'es-CO': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      'en-US': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
    const meses = {
      'es-CO': ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      'en-US': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };

    // Get the day of the week and the day of the month in the desired language
    const diaSemana = diasSemana[region][fechaObj.getUTCDay()];
    const diaMes = fechaObj.getUTCDate();
    const mes = meses[region][fechaObj.getUTCMonth()];

    // Concatenate the values obtained to form the date string in the desired format
    let fechaFormateada = region === 'es-CO'
      ? `${diaSemana} ${diaMes} de ${mes}`
      : `${diaSemana}, ${mes} ${diaMes}`;

    return fechaFormateada;
  }

  private BlockHasTheSameTimeAsSchedule(startTimeInput, endTimeInput){
    const userLocale = navigator.language;
    let scheduleTime = new Date(this.appointment.start).toLocaleTimeString(userLocale, {hour12: false});
    const timeObj = moment(scheduleTime, "HH:mm:ss");

    // Compare the time with a start time and end time
    // const startTimeString = "06:00:00";
    // const endTimeString = "15:00:00";
    const startTimeObj = moment(startTimeInput, "HH:mm:ss");
    const endTimeObj = moment(endTimeInput, "HH:mm:ss").subtract(1, 'minute');

    // The null parameter is used to skip the precision parameter, and the "[]" parameter is used to indicate that the range is inclusive.
    if (timeObj.isBetween(startTimeObj, endTimeObj, null, "[]")) {
      return true;
    } else {
      return false;
    }
  }


  getBlockedSchedulesToSchedule(): Observable<any> {
    return this.customScheduleService.getSchedulerByAdvisor(this.appointment.advisor.advisorId)
      .pipe(
        map((data: any) => {
          let response = false;

          let sameNameWorkshopService = data.blockedservicesByServiceAdvisor.filter(el => {
            return el.serviceName === this.appointment.typeOfService.serviceName &&
              el.brandName === this.appointment.brand.brandName &&
              new Date(el.initialDate).getDate() === new Date(this.appointment.start).getDate() &&
              new Date(el.initialDate).getMonth() === new Date(this.appointment.start).getMonth() &&
              new Date(el.initialDate).getFullYear() === new Date(this.appointment.start).getFullYear();
          });

          let sameNameAdvisorService = data.serviceAdvisorBlockedServices.filter(el => {
            return el.serviceName === this.appointment.typeOfService.serviceName &&
              el.brandName === this.appointment.brand.brandName &&
              new Date(el.initialDateBlockedServices).getDate() === new Date(this.appointment.start).getDate() &&
              new Date(el.initialDateBlockedServices).getMonth() === new Date(this.appointment.start).getMonth() &&
              new Date(el.initialDateBlockedServices).getFullYear() === new Date(this.appointment.start).getFullYear();
          });

          // Parse the time string into a moment object
          for (let i = 0; i < sameNameWorkshopService.length; i++) {
            if (this.BlockHasTheSameTimeAsSchedule(sameNameWorkshopService[i].hourInitial, sameNameWorkshopService[i].hourFinal)) {
              response = true;
              break;
            }
          }

          if (!response) {
            // object times have different names for workshop and advisro blocked services -.-!
            for (let i = 0; i < sameNameAdvisorService.length; i++) {
              if (this.BlockHasTheSameTimeAsSchedule(sameNameAdvisorService[i].hourInitialBlockedServices, sameNameAdvisorService[i].hourFinaBlockedServices)) {
                response = true;
                break;
              }
            }
          }

          return response;
        }) ,catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(error);
        })
      );
  }

  validatorsForm():boolean{
    const invalidForms=
    this.scheduleForm.get('owner')!.invalid
    ||this.scheduleForm.get('schedule')!.invalid
    ||this.scheduleForm.get('termsAndPolitics')!.invalid
    const ownerOnsiteValidation=
    this.scheduleForm.get('representative')!.get('duenoSePresentara')!.value
    if(!invalidForms&&ownerOnsiteValidation){
      return false
    }
    else if(!invalidForms&&!ownerOnsiteValidation){
      return this.scheduleForm.get('representative')!.invalid
    }

    else{
      return true
    }

  }

  // Ownner getters
  get nombres (){
    return this.scheduleForm.get("owner")?.get("nombres")
  }

  get apellidos (){
    return this.scheduleForm.get("owner")?.get("apellidos")
  }
  get tipoDePersona (){
    return this.scheduleForm.get("owner")?.get("tipoDePersona")
  }
  get tipoDeDocumento (){
    return this.scheduleForm.get("owner")?.get("tipoDeDocumento")
  }

  get numeroDeDocumento (){
    return this.scheduleForm.get("owner")?.get("numeroDeDocumento")
  }

  get relacionClienteVehiculo (){
    return this.scheduleForm.get("owner")?.get("relacionClienteVehiculo")
  }

  get celular (){
    return this.scheduleForm.get("owner")?.get("celular")
  }

  get email (){
    return this.scheduleForm.get("owner")?.get("email")
  }

  get placa (){
    return this.scheduleForm.get("owner")?.get("placa")
  }

  // TODO: Modify this to be only vin not vinNo
  get vinNo (){
    return this.scheduleForm.get("owner")?.get("vin")
  }

  get year (){
    return this.scheduleForm.get("owner")?.get("año")
  }

  get model (){
    return this.scheduleForm.get("owner")?.get("model")
  }

  get asesor (){
    return this.scheduleForm.get("schedule")?.get("asesor")
  }

  get terminos (){
    return this.scheduleForm.get("termsAndPolitics")?.get("terminos")
  }

  get politicas (){
    return this.scheduleForm.get("termsAndPolitics")?.get("politicas")
  }

  // Representative Getters
  get nombresRepresentante (){
    return this.scheduleForm.get("representative")?.get("nombresRepresentante")
  }

  get apellidosRepresentante (){
    return this.scheduleForm.get("representative")?.get("apellidosRepresentante")
  }

  get tipoDeDocumentoRepresentante (){
    return this.scheduleForm.get("representative")?.get("tipoDeDocumentoRepresentante")
  }

  get numeroDeDocumentoRepresentante (){
    return this.scheduleForm.get("representative")?.get("numeroDeDocumentoRepresentante")
  }

  get relacionClienteVehiculoRepresentante (){
    return this.scheduleForm.get("representative")?.get("relacionClienteVehiculoRepresentante")
  }

  get celularRepresentante (){
    return this.scheduleForm.get("representative")?.get("celularRepresentante")
  }

  get emailRepresentante (){
    return this.scheduleForm.get("representative")?.get("emailRepresentante")
  }

  get hora (){
    return this.scheduleForm.get("schedule")?.get("hora")
  }

  get kilometraje (){
    return this.scheduleForm.get("schedule")?.get("kilometraje")
  }

  get canal (){
    return this.scheduleForm.get("schedule")?.get("canal")
  }

}
